// @ts-nocheck
// /* eslint-disable react/prop-types */
// import {
//   Box,
//   Button,
//   Modal,
//   Typography,
//   Divider,
//   useMediaQuery,
// } from "@mui/material";
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import theme from "../../../theme";
// import {
//   CustomButton,
//   SecondaryButton,
// } from "../../../components/Custom/CustomButton";
// import PropTypes from "prop-types";

// import WestIcon from "@mui/icons-material/West";

// import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
// import { alertDialogAciton } from "../../../store/actions/auth";
// import { apiRequest } from "../../../services/apiService";
// import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
// import dayjs from "dayjs";
// import {
//   applyOpportunityAction,
//   clearContractorAppliedListAction,
//   updateResponseAnyway,
// } from "../../../store/actions/opportunities";
// import {
//   convertFromUTCToGivenTimezone,
//   formatAMPM,
// } from "../../../utils/methods/dateAndTimeMethods";
// import { clearScheduleDataAction } from "../../../store/actions/contractorScheduleTabActions";
// import { dateRegex } from "../../../utils/constants/dateRegex";
// import { phoneNumberFormat } from "../../../utils/methods/formatters";
// import { ArrowForward } from "@mui/icons-material";
// import GenericTransparentBtn from "../../../components/Custom/GenericTransparentBtn";

// const CalendarMiddleware = ({
//   selectedRow,
//   showButtons = true,
//   opportunityId,
//   data: rowData,
//   setCount,
//   handleClose
// }) => {
//   console.log(rowData, "CalendarMiddleware");
//   // media query hooks...
//   const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
//   const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
//   // media query hooks...

//   const navigate = useNavigate();

//   const { oppLoading: loading } = useSelector((state) => state.opportunities);

//   const dispatch = useDispatch();
//   const [data, setData] = React.useState(null);
//   const [isLoading, setIsLoading] = React.useState(false);
//   const [contractorStatus, setContractorStatus] =
//     React.useState("not responded");
//   const [open, setOpen] = React.useState(true);

//   // React.useEffect(() => {
//   //   const fetchData = async () => {
//   //     setIsLoading(true);
//   //     const { response, error } = await apiRequest({
//   //       method: "GET",
//   //       url: "getOpportunityById",
//   //       version: "v2",
//   //       params: {
//   //         id: rowData?.state?.positions?.[0]?.id,
//   //         opportunityId: rowData?.state?.positions?.[0]?.opportunityId,
//   //       },
//   //       isToken: true,
//   //     });
//   //     if (response?.status === 200) {
//   //       setData(response?.data?.data);
//   //       setIsLoading(false);
//   //     } else if (response?.status !== 200 || error) {
//   //       setData(null);
//   //       setIsLoading(false);
//   //       dispatch(
//   //         alertDialogAciton({
//   //           open: true,
//   //           title: "Error",
//   //           message:
//   //             error?.response?.data?.message || "Fail to get opportunity!",
//   //         }),
//   //       );
//   //       setOpen(false);
//   //     }
//   //   };

//   //   if (rowData?.type !== "schedule") {
//   //     fetchData();
//   //   }
//   // }, []);

//   React.useEffect(() => {
//     if (data?.applied) {
//       setContractorStatus("Applied");
//     } else if (data?.declined) {
//       setContractorStatus("Declined");
//     }
//   }, [data]);

//   const getColorOfStatus = (status) => {
//     switch (status?.toLowerCase()) {
//       case "draft":
//         return "#4D4D4D";
//       case "not responded":
//         return "#4D4D4D";
//       case "applied":
//         return "#02493E";
//       case "declined":
//         return "#371414";

//       default:
//         return "white";
//     }
//   };

//   const getTextColorOfStatus = (status) => {
//     switch (status?.toLowerCase()) {
//       case "draft":
//         return "black";
//       case "not responded":
//         return "white";
//       case "applied":
//         return "#07EEC5";
//       case "declined":
//         return "#FF4B4B";

//       default:
//         return "black";
//     }
//   };

//   const handleAcceptClick = () => {
//     dispatch(
//       applyOpportunityAction({
//         payload: {
//           data: {
//             response: "applied",
//           },
//           id: opportunityId,
//           params: {
//             positionId: data?.positionId,
//             sessionId: data?.sessionId,
//             Id: opportunityId,
//           },
//         },
//         successCallback: (rdata) => {
//           if (!rdata?.scheduledConflictContractors?.length) {
//             dispatch(
//               alertDialogAciton({
//                 title: "Success",
//                 message: "Opportunity accepted successfully!",
//                 open: true,
//               }),
//             );
//             dispatch(clearContractorAppliedListAction());
//             dispatch(clearScheduleDataAction());
//             setOpen(false);
//             setCount((prev) => prev + 1);
//           } else {
//             dispatch(
//               alertDialogAciton({
//                 open: true,
//                 title: "Conflict Alert",
//                 message: "You have a schedule conflict with this opportunity!",
//                 onOk: () => {
//                   dispatch(
//                     updateResponseAnyway({
//                       payload: {
//                         data: {
//                           response: "applied",
//                         },
//                         id: opportunityId,
//                         params: {
//                           positionId: data?.positionId,
//                           sessionId: data?.sessionId,
//                           Id: opportunityId,
//                         },
//                       },
//                       successCallback: () => {
//                         dispatch(
//                           alertDialogAciton({
//                             title: "Success",
//                             message: "Opportunity accepted successfully!",
//                             open: true,
//                           }),
//                         );
//                         dispatch(clearContractorAppliedListAction());
//                         dispatch(clearScheduleDataAction());
//                         setOpen(false);
//                         setCount((prev) => prev + 1);
//                       },
//                       failureCallback: (msg) => {
//                         dispatch(
//                           alertDialogAciton({
//                             title: "Error",
//                             message: msg || "Fail to accept opportunity!",
//                             open: true,
//                           }),
//                         );
//                       },
//                     }),
//                   );
//                 },
//                 okLabel: "Accept Anyway",
//               }),
//             );
//           }
//         },
//         failureCallback: (msg) => {
//           dispatch(
//             alertDialogAciton({
//               title: "Error",
//               message: msg?.message || "Fail to accept opportunity!",
//               open: true,
//             }),
//           );
//         },
//       }),
//     );
//   };

//   const handleDeclineClick = () => {
//     dispatch(
//       applyOpportunityAction({
//         payload: {
//           data: {
//             response: "declined",
//           },
//           id: opportunityId,
//           params: {
//             positionId: data?.positionId,
//             sessionId: data?.sessionId,
//             Id: opportunityId,
//           },
//         },
//         successCallback: () => {
//           dispatch(
//             alertDialogAciton({
//               title: "Success",
//               message: "Opportunity denied successfully!",
//               open: true,
//             }),
//           );
//           setOpen(false);
//           setCount((prev) => prev + 1);
//         },
//         failureCallback: () => {
//           dispatch(
//             alertDialogAciton({
//               title: "Error",
//               message: "Fail to accept opportunity!",
//               open: true,
//             }),
//           );
//         },
//       }),
//     );
//   };

//   const closeHandler = () => {
//     setOpen(false);
//     if (handleClose) {
//       handleClose();
//     }
//   }

//   console.log(rowData, "rowData")

//   return (
//     <Modal
//       // className="modelBox"
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//       open={open}
//       onClose={closeHandler}
//       // aria-labelledby="modal-modal-title"
//       // aria-describedby="modal-modal-description"
//     >
//       <Box
//         sx={{
//           position: "relative",
//           // top: "50%",
//           // left: "50%",
//           // transform: "translate(-50%, -50%)",
//           width: isMediumScreen ? "95%" : "60%",
//           // minWidth: "880px",
//           // minHeight: isLoading ? "60%" : "50%",
//           height: "auto",
//           maxHeight: "95%",
//           maxWidth: "1080px",
//           // minHeight: "500px",
//           boxShadow: 24,
//           p: 4,
//           borderRadius: "16px",
//           padding: "40px",
//           gap: "30px",
//           border: "2px solid #D175B6",
//           backgroundColor: "#000",
//           display: "flex",
//           flexDirection: "column",
//           zIndex: 9,
//           overflowY: "auto",
//           "@media (max-width: 600px)": {
//             minWidth: "0px",
//             width: "97vw",
//             maxHeight: "95vh",
//             overflowY: "auto",
//           },
//         }}
//         className="custom-scroll-design"
//       >
//         {rowData?.type !== "schedule" ? (isLoading || loading) && (
//           <LoadingOverlay open={isLoading || loading} />
//         ) : null}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "space-between",
//           }}
//         >
//           <Button
//             onClick={() => setOpen(false)}
//             sx={{
//               minWidth: "0",
//               height: "auto",
//               background: "none",
//               padding: isSmallScreen ? "0" : "0.5rem",
//               boxShadow: "none",
//               border: isSmallScreen
//                 ? "none"
//                 : `1px solid ${getCssVariableHandler({
//                     variableName: "--primary-pink-hex",
//                   })}`,
//               zIndex: "10",
//               borderRadius: "50%",
//               cursor: "pointer !important",
//               "&:hover": {
//                 minWidth: "0",
//                 background: "none",
//                 padding: isSmallScreen ? "0" : "0.5rem",
//                 boxShadow: "none",
//                 border: isSmallScreen
//                   ? "none"
//                   : `1px solid ${getCssVariableHandler({
//                       variableName: "--primary-pink-hex",
//                     })}`,
//                 borderRadius: "50%",
//               },
//             }}
//           >
//             <WestIcon />
//           </Button>
//           <Typography
//             id="modal-modal-title"
//             variant="h6"
//             component="h2"
//             marginBottom="20px"
//             sx={{
//               float: "left",
//               margin: "0 auto",
//               fontSize: "32px",
//               zIndex: "10",
//             }}
//           >
//             {dayjs(rowData?.type === "schedule" ? rowData?.state?.startDate : rowData?.state?.positions?.[0]?.startDate)?.format("LL")}
//           </Typography>
//         </Box>
//         {!isLoading ? (
//           <>
//             <Box sx={{ width: "100%" }}>
//               {/* <Box
//                 sx={{
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   width: "100%",
//                   height: "auto",
//                   padding: "10px",
//                   gap: "5px",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   zIndex: "10",
//                 }}
//               >
//                 <Typography sx={{ fontSize: "20px" }}>
//                   Event Name: {rowData?.type === "schedule" ? rowData?.state?.eventName : data?.eventName}
//                 </Typography>
//                 {data?.coordinators?.length > 0 && (
//                   <Typography sx={{ fontSize: "14px", textWrap: "wrap" }}>
//                     Coordinator{data?.coordinators?.length > 1 ? "s" : ""}:{" "}
//                     {data?.coordinators
//                       ?.map(
//                         (item) =>
//                           `${item?.name} - (${phoneNumberFormat(item?.mobile)})`,
//                       )
//                       .join(", ")}
//                   </Typography>
//                 )}
//               </Box> */}
//               {/* {data?.adminMessage && (
//                 <Box
//                   sx={{
//                     width: "100%",
//                     textAlign: "center",
//                     mt: "0.5rem",
//                   }}
//                 >
//                   <Typography sx={{ fontSize: "14px" }}>
//                     Admin Message: {data?.adminMessage}
//                   </Typography>
//                 </Box>
//               )} */}
//             </Box>

//             {rowData?.state?.positions?.find?.(item => {
//               return (item?.type === "schedule")
//             }) ? <Box
//               sx={{
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 backgroundColor: "#64646466",
//                 padding: "1rem",
//                 borderRadius: "0.5rem",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "space-between",
//                   // alignItems: "center",
//                   gap: "1rem",
//                 }}
//               >
//                 <Typography sx={{ color: "white" }}>
//                   Schedule
//                 </Typography>
//                 {rowData?.state?.positions?.map((item, itemIdx) => {
//                   if (item?.type === "schedule") {
//                     return (
//                       <React.Fragment key={item?.id}>
//                       <Box
//                         sx={{
//                           padding: "1rem",
//                           display: "flex",
//                           gap: "1rem",
//                           border: `1px solid ${getCssVariableHandler({
//                             variableName: "--primary-pink-rgb"
//                           })}`,
//                           borderRadius: "1rem"
//                         }}
//                       >
//                         <Typography sx={{ color: "white" }}>
//                           {item?.positionName}
//                         </Typography>
//                         <Typography sx={{ color: "white" }}>
//                           {dayjs(item?.startDate).format("LL")}
//                         </Typography>
//                       </Box>
//                     </React.Fragment>
//                     )
//                    } else {
//                     return null;
//                    }
//                 })}
//               </Box>

//               <Button
//                 sx={{
//                   // color: getTextColorOfStatus(contractorStatus),
//                   // border: `1px solid ${getColorOfStatus(contractorStatus)}`,
//                   position: "absolute",
//                   // top: "50%",
//                   right: "1rem",
//                   // transform: `translateX(-100%)`,
//                   backgroundColor: getCssVariableHandler({
//                     variableName: "--primary-pink-rgb"
//                   }),
//                   minWidth: "0",
//                   padding: "1.8rem 0.75rem !important",
//                   borderRadius: "50%",
//                   textAlign: "center",
//                   height: "35px",
//                   textTransform: "capitalize",
//                 }}
//                 onClick={() => {
//                   // if (rowData?.type === "schedule") {
//                     const data = rowData?.state?.positions?.find?.(item => {
//                       return (item?.type === "schedule")
//                     });
//                     navigate("/schedule", { state: { ...data, id: data?._id } });
//                   // } else if (rowData?.type === "single") {
//                   //   navigate("/opportunities", {
//                   //     state: {
//                   //       ...rowData?.state,
//                   //       id: rowData?.state?.positions?.[0]?.id,
//                   //       positionId: rowData?.state?.positions?.[0]?.positionId,
//                   //     },
//                   //   });
//                   // } else {
//                   //   navigate("/opportunities", {
//                   //     state: {
//                   //       ...rowData?.state,
//                   //     },
//                   //   });
//                   // }

//                   closeHandler();
//                 }}
//               >
//                 {/* {contractorStatus} */}
//                 <ArrowForward
//                   sx={{
//                     fontSize: "2rem",
//                     color: getCssVariableHandler({
//                       variableName: "--font-rgb"
//                     }),
//                   }}
//                 />
//               </Button>
//             </Box> : null}

//             {rowData?.state?.positions?.find?.(item => {
//               return (item?.type === "multiple")
//             }) ? <Box
//               sx={{
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 backgroundColor: "#64646466",
//                 padding: "1rem",
//                 borderRadius: "0.5rem",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "space-between",
//                   // alignItems: "center",
//                   gap: "1rem",
//                 }}
//               >
//                 <Typography sx={{ color: "white" }}>
//                   Multiple
//                 </Typography>
//                 {rowData?.state?.positions?.map((item, itemIdx) => {
//                   if (item?.type === "multiple") {
//                     return (
//                       <React.Fragment key={item?.id}>
//                       <Box
//                         sx={{
//                           padding: "1rem",
//                           display: "flex",
//                           gap: "1rem",
//                           border: `1px solid ${getCssVariableHandler({
//                             variableName: "--primary-pink-rgb"
//                           })}`,
//                           borderRadius: "1rem"
//                         }}
//                       >
//                         <Typography sx={{ color: "white" }}>
//                           {item?.positionName}
//                         </Typography>
//                         <Typography sx={{ color: "white" }}>
//                           {dayjs(item?.startDate).format("LL")}
//                         </Typography>
//                       </Box>
//                     </React.Fragment>
//                     )
//                    } else {
//                     return null;
//                    }
//                 })}
//               </Box>

//               <Button
//                 sx={{
//                   // color: getTextColorOfStatus(contractorStatus),
//                   // border: `1px solid ${getColorOfStatus(contractorStatus)}`,
//                   position: "absolute",
//                   // top: "50%",
//                   right: "1rem",
//                   // transform: `translateX(-100%)`,
//                   backgroundColor: getCssVariableHandler({
//                     variableName: "--primary-pink-rgb"
//                   }),
//                   minWidth: "0",
//                   padding: "1.8rem 0.75rem !important",
//                   borderRadius: "50%",
//                   textAlign: "center",
//                   height: "35px",
//                   textTransform: "capitalize",
//                 }}
//                 onClick={() => {
//                   if (rowData?.type === "schedule") {
//                     navigate("/schedule", { state: { ...rowData?.state, id: rowData?.state?._id } });
//                   } else if (rowData?.type === "single") {
//                     navigate("/opportunities", {
//                       state: {
//                         ...rowData?.state,
//                         id: rowData?.state?.positions?.[0]?.id,
//                         positionId: rowData?.state?.positions?.[0]?.positionId,
//                       },
//                     });
//                   } else {
//                     navigate("/opportunities", {
//                       state: {
//                         ...rowData?.state,
//                       },
//                     });
//                   }

//                   closeHandler();
//                 }}
//               >
//                 {/* {contractorStatus} */}
//                 <ArrowForward
//                   sx={{
//                     fontSize: "2rem",
//                     color: getCssVariableHandler({
//                       variableName: "--font-rgb"
//                     }),
//                   }}
//                 />
//               </Button>
//             </Box> : null}

//             {rowData?.state?.positions?.find?.(item => {
//               return (item?.type === "single")
//             }) ? <Box
//               sx={{
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 backgroundColor: "#64646466",
//                 padding: "1rem",
//                 borderRadius: "0.5rem",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "space-between",
//                   // alignItems: "center",
//                   gap: "1rem",
//                 }}
//               >
//                 <Typography sx={{ color: "white" }}>
//                   Single
//                 </Typography>
//                 {rowData?.state?.positions?.map((item, itemIdx) => {
//                   if (item?.type === "single") {
//                     return (
//                       <React.Fragment key={item?.id}>
//                       <Box
//                         sx={{
//                           padding: "1rem",
//                           display: "flex",
//                           gap: "1rem",
//                           border: `1px solid ${getCssVariableHandler({
//                             variableName: "--primary-pink-rgb"
//                           })}`,
//                           borderRadius: "1rem"
//                         }}
//                       >
//                         <Typography sx={{ color: "white" }}>
//                           {item?.positionName}
//                         </Typography>
//                         <Typography sx={{ color: "white" }}>
//                           {dayjs(item?.startDate).format("LL")}
//                         </Typography>
//                       </Box>
//                     </React.Fragment>
//                     )
//                    } else {
//                     return null;
//                    }
//                 })}
//               </Box>

//               <Button
//                 sx={{
//                   // color: getTextColorOfStatus(contractorStatus),
//                   // border: `1px solid ${getColorOfStatus(contractorStatus)}`,
//                   position: "absolute",
//                   // top: "50%",
//                   right: "1rem",
//                   // transform: `translateX(-100%)`,
//                   backgroundColor: getCssVariableHandler({
//                     variableName: "--primary-pink-rgb"
//                   }),
//                   minWidth: "0",
//                   padding: "1.8rem 0.75rem !important",
//                   borderRadius: "50%",
//                   textAlign: "center",
//                   height: "35px",
//                   textTransform: "capitalize",
//                 }}
//                 onClick={() => {
//                   if (rowData?.type === "schedule") {
//                     navigate("/schedule", { state: { ...rowData?.state, id: rowData?.state?._id } });
//                   } else if (rowData?.type === "single") {
//                     navigate("/opportunities", {
//                       state: {
//                         ...rowData?.state,
//                         id: rowData?.state?.positions?.[0]?.id,
//                         positionId: rowData?.state?.positions?.[0]?.positionId,
//                       },
//                     });
//                   } else {
//                     navigate("/opportunities", {
//                       state: {
//                         ...rowData?.state,
//                       },
//                     });
//                   }

//                   closeHandler();
//                 }}
//               >
//                 {/* {contractorStatus} */}
//                 <ArrowForward
//                   sx={{
//                     fontSize: "2rem",
//                     color: getCssVariableHandler({
//                       variableName: "--font-rgb"
//                     }),
//                   }}
//                 />
//               </Button>
//             </Box> : null}

//             {/* <Box
//               sx={{
//                 border: `1px solid ${theme.palette.secondary.main}`,
//                 width: "100%",
//                 borderRadius: "3px",
//                 height: "auto",
//                 padding: "10px",
//                 gap: "10px",
//                 display: "flex",
//                 flexDirection: "column",
//                 fontSize: "14px",
//                 zIndex: "10",
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   zIndex: "10",
//                   "& p": {
//                     width: "50%",
//                   },
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     margin: "0 auto",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Date Start:{" "}
//                   </span>
//                   {dayjs(data?.startDate).format("DD MMM, YYYY")}
//                 </Typography>

//                 <Typography
//                   sx={{
//                     margin: "0 auto",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Overnight Shift:{" "}
//                   </span>
//                   {data?.overNightShift ? "Yes" : "No"}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   zIndex: "10",
//                   "& p": {
//                     width: "50%",
//                   },
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     {" "}
//                     Time In:{"  "}
//                   </span>
//                   {dateRegex.test(data?.timeIn?.split?.("T")?.[0])
//                     ? formatAMPM(
//                         convertFromUTCToGivenTimezone({
//                           dateStr: data?.timeIn,
//                           timezone: data?.timezone,
//                         }),
//                       )
//                     : "TBD"}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     margin: "0 auto",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Time End:{"  "}
//                   </span>
//                   {dateRegex.test(data?.timeOut?.split?.("T")?.[0])
//                     ? formatAMPM(
//                         convertFromUTCToGivenTimezone({
//                           dateStr: data?.timeOut,
//                           timezone: data?.timezone,
//                         }),
//                       )
//                     : "TBD"}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   "& p": {
//                     width: "50%",
//                   },
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Complexity:{"  "}
//                   </span>
//                   {data?.complexity}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     margin: "0 28%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Attire:{"  "}
//                   </span>
//                   {data?.attire}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     {" "}
//                     Meal Option:{"  "}
//                   </span>
//                   {data?.info}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     {" "}
//                     Comments:{"  "}
//                   </span>
//                   {data?.comments}
//                 </Typography>
//               </Box>
//             </Box> */}
//             {/* <Box
//               sx={{
//                 backgroundColor: `${theme.palette.secondary.main}`,
//                 width: "100%",
//                 borderRadius: "3px",
//                 height: "auto",
//                 padding: "10px",
//                 gap: "5px",
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 fontSize: "14px",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "50%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   opacity: "0.5",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: "rgba(0, 0, 0, 0.5)",
//                     zIndex: -1,
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "relative",
//                     zIndex: "10",
//                     color: "rgba(245,245,245,1) !important",
//                   }}
//                 >
//                   <Typography>{data?.location}</Typography>
//                   <Typography>{` ${rowData?.venue}, ${rowData?.venueAddressLine1}, ${rowData?.venueCity}, ${rowData?.venueState}, ${rowData?.venueZipCode}`}</Typography>
//                 </Box>
//               </Box>
//               <Box
//                 sx={{
//                   width: "50%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   zIndex: "10",
//                 }}
//               >
//                 <iframe
//                   width="100%"
//                   height="100%"
//                   loading="lazy"
//                   allowfullscreen
//                   src={`https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_API_KEY}${
//                     data?.lat && data?.long
//                       ? `&center=${data.lat},${data.long}`
//                       : ""
//                   }&q=${encodeURIComponent(
//                     [
//                       rowData?.venue,
//                       rowData?.venueAddressLine1,
//                       rowData?.venueCity,
//                       rowData?.venueState,
//                       rowData?.venueZipCode,
//                     ]
//                       .filter(Boolean) // Remove falsy values
//                       .join(", "), // Combine valid parts with a comma and space
//                   )}`}
//                 ></iframe>
//               </Box>
//             </Box> */}
//             {/* {showButtons && data?.pending && (
//               <Box
//                 sx={{
//                   width: "50%",
//                   height: "auto",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: "10px",
//                   margin: "0 auto",
//                 }}
//               >
//                 <CustomButton onClick={handleAcceptClick}>
//                   <Typography sx={{ fontSize: "1.5rem" }}>Accept</Typography>
//                 </CustomButton>
//                 <SecondaryButton onClick={handleDeclineClick}>
//                   <Typography sx={{ fontSize: "1.5rem" }}>Decline</Typography>
//                 </SecondaryButton>
//               </Box>
//             )} */}
//           </>
//         ) : null}
//       </Box>
//     </Modal>
//   );
// }

// export default CalendarMiddleware;

// // CalendarMiddleware.propTypes = {
// //   open: PropTypes.bool,
// //   setOpen: PropTypes.func,
// //   selectedRow: PropTypes.object,
// //   showButtons: PropTypes.bool,
// //   opportunityId: PropTypes.string,
// //   id: PropTypes.string,
// //   data: PropTypes.object,
// //   setCount: PropTypes.func,
// // };

// -----------------------------------------------------------------------------------------------------------
/* eslint-disable react/prop-types */
import { Box, Button, Modal, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import theme from "../../../theme";

import WestIcon from "@mui/icons-material/West";

import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { alertDialogAciton } from "../../../store/actions/auth";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import dayjs from "dayjs";
import {
  applyOpportunityAction,
  clearContractorAppliedListAction,
  updateResponseAnyway,
} from "../../../store/actions/opportunities";

import { clearScheduleDataAction } from "../../../store/actions/contractorScheduleTabActions";
import UnderlineButton from "../../../components/Custom/UnderlineButton";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";

const CalendarMiddleware = ({
  selectedRow,
  showButtons = true,
  opportunityId,
  data: rowData,
  setCount,
  handleClose,
  holdAndPre,
}) => {
  const COLOR = {
    SCHEDULED: {
      bg: "#4caf50",
      border: "#388e3c",
    },
    APPLIED: {
      bg: "#2196f3",
      border: "#1976d2",
    },
    IN_PROGRESS: {
      bg: "#ff9800",
      border: "#f57c00",
    },
    NOT_RESPONDED: {
      bg: "#504c4c",
      border: "#504c4c",
    },
  };

  // media query hooks...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks...

  const navigate = useNavigate();

  const { oppLoading: loading } = useSelector((state) => state.opportunities);

  const dispatch = useDispatch();
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [contractorStatus, setContractorStatus] =
    React.useState("not responded");
  // const [open, setOpen] = React.useState(true);

  // React.useEffect(() => {
  //   const fetchData = async () => {
  //     setIsLoading(true);
  //     const { response, error } = await apiRequest({
  //       method: "GET",
  //       url: "getOpportunityById",
  //       version: "v2",
  //       params: {
  //         id: rowData?.state?.positions?.[0]?.id,
  //         opportunityId: rowData?.state?.positions?.[0]?.opportunityId,
  //       },
  //       isToken: true,
  //     });
  //     if (response?.status === 200) {
  //       setData(response?.data?.data);
  //       setIsLoading(false);
  //     } else if (response?.status !== 200 || error) {
  //       setData(null);
  //       setIsLoading(false);
  //       dispatch(
  //         alertDialogAciton({
  //           open: true,
  //           title: "Error",
  //           message:
  //             error?.response?.data?.message || "Fail to get opportunity!",
  //         }),
  //       );
  //       setOpen(false);
  //     }
  //   };

  //   if (rowData?.type !== "schedule") {
  //     fetchData();
  //   }
  // }, []);

  React.useEffect(() => {
    if (data?.applied) {
      setContractorStatus("Applied");
    } else if (data?.declined) {
      setContractorStatus("Declined");
    }
  }, [data]);

  const getColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "#4D4D4D";
      case "not responded":
        return "#4D4D4D";
      case "applied":
        return "#02493E";
      case "declined":
        return "#371414";
      case "schedule":
        return "#4c8f3c";

      default:
        return "white";
    }
  };

  const getTextColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "black";
      case "not responded":
        return "white";
      case "applied":
        return "#07EEC5";
      case "declined":
        return "#FF4B4B";
      case "schedule":
        return "white";

      default:
        return "black";
    }
  };

  const handleAcceptClick = () => {
    dispatch(
      applyOpportunityAction({
        payload: {
          data: {
            response: "applied",
          },
          id: opportunityId,
          params: {
            positionId: data?.positionId,
            sessionId: data?.sessionId,
            Id: opportunityId,
          },
        },
        successCallback: (rdata) => {
          if (!rdata?.scheduledConflictContractors?.length) {
            dispatch(
              alertDialogAciton({
                title: "Success",
                message: "Opportunity accepted successfully!",
                open: true,
              }),
            );
            dispatch(clearContractorAppliedListAction());
            dispatch(clearScheduleDataAction());
            // setOpen(false);
            handleClose();
            setCount((prev) => prev + 1);
          } else {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Conflict Alert",
                message: "You have a schedule conflict with this opportunity!",
                onOk: () => {
                  dispatch(
                    updateResponseAnyway({
                      payload: {
                        data: {
                          response: "applied",
                        },
                        id: opportunityId,
                        params: {
                          positionId: data?.positionId,
                          sessionId: data?.sessionId,
                          Id: opportunityId,
                        },
                      },
                      successCallback: () => {
                        dispatch(
                          alertDialogAciton({
                            title: "Success",
                            message: "Opportunity accepted successfully!",
                            open: true,
                          }),
                        );
                        dispatch(clearContractorAppliedListAction());
                        dispatch(clearScheduleDataAction());
                        // setOpen(false);
                        handleClose();
                        setCount((prev) => prev + 1);
                      },
                      failureCallback: (msg) => {
                        dispatch(
                          alertDialogAciton({
                            title: "Error",
                            message: msg || "Fail to accept opportunity!",
                            open: true,
                          }),
                        );
                      },
                    }),
                  );
                },
                okLabel: "Accept Anyway",
              }),
            );
          }
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: msg?.message || "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleDeclineClick = () => {
    dispatch(
      applyOpportunityAction({
        payload: {
          data: {
            response: "declined",
          },
          id: opportunityId,
          params: {
            positionId: data?.positionId,
            sessionId: data?.sessionId,
            Id: opportunityId,
          },
        },
        successCallback: () => {
          dispatch(
            alertDialogAciton({
              title: "Success",
              message: "Opportunity denied successfully!",
              open: true,
            }),
          );
          // setOpen(false);
          handleClose();
          setCount((prev) => prev + 1);
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const closeHandler = () => {
    // setOpen(false);
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <Modal
      // className="modelBox"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      open={open}
      onClose={() => handleClose(false)}
      // aria-labelledby="modal-modal-title"
      // aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          // top: "50%",
          // left: "50%",
          // transform: "translate(-50%, -50%)",
          width: isMediumScreen ? "95%" : "60%",
          // minWidth: "880px",
          // minHeight: isLoading ? "60%" : "50%",
          height: "auto",
          maxHeight: "95%",
          maxWidth: "1080px",
          // minHeight: "500px",
          boxShadow: 24,
          p: 4,
          borderRadius: "16px",
          padding: "40px",
          gap: "1rem",
          border: "2px solid #D175B6",
          backgroundColor: "#000",
          display: "flex",
          flexDirection: "column",
          zIndex: 9,
          overflowY: "auto",
          "@media (max-width: 600px)": {
            minWidth: "0px",
            width: "97vw",
            maxHeight: "95vh",
            overflowY: "auto",
          },
        }}
        className="custom-scroll-design"
      >
        {rowData?.type !== "schedule"
          ? (isLoading || loading) && (
              <LoadingOverlay open={isLoading || loading} />
            )
          : null}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={() => handleClose(false)}
            sx={{
              minWidth: "0",
              height: "auto",
              background: "none",
              padding: isSmallScreen ? "0" : "0.5rem",
              boxShadow: "none",
              border: isSmallScreen
                ? "none"
                : `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
              zIndex: "10",
              borderRadius: "50%",
              cursor: "pointer !important",
              "&:hover": {
                minWidth: "0",
                background: "none",
                padding: isSmallScreen ? "0" : "0.5rem",
                boxShadow: "none",
                border: isSmallScreen
                  ? "none"
                  : `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })}`,
                borderRadius: "50%",
              },
            }}
          >
            <WestIcon />
          </Button>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            marginBottom="20px"
            sx={{
              float: "left",
              margin: "0 auto",
              fontSize: "32px",
              zIndex: "10",
            }}
          >
            {dayjs(
              rowData?.state?.schedule?.length > 0
                ? rowData?.state?.schedule?.[0]?.startDate
                : rowData?.state?.multiple?.length > 0
                  ? rowData?.state?.multiple?.[0]?.data?.positions?.[0]
                      ?.startDate
                  : (rowData?.state?.single?.positions?.[0]?.startDate ??
                    holdAndPre?.date?.split("T")?.[0]),
            )?.format("LL")}
          </Typography>
        </Box>
        {!isLoading ? (
          <>
            {holdAndPre ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  sx={{ width: "100%", textAlign: "center" }}
                  color={theme.palette.green.main}
                >{`${holdAndPre?.holdDownShift === "holdDown" ? "Hold Down Shift " : "Pre Booked "} by ${holdAndPre?.bookedByDetails?.fullName} on ${dayjs(holdAndPre?.createdAt).format("ddd MM/DD/YYYY [at] hh:mm a")}`}</Typography>
                <Typography>Message: {holdAndPre?.comment}</Typography>
              </Box>
            ) : null}

            {rowData?.state?.schedule?.length > 0 ? (
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  backgroundColor: "#64646466",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "space-between",
                    // alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: "1.25rem",
                        fontWeight: "500",
                      }}
                    >
                      Scheduled
                    </Typography>
                  </Box>
                  {rowData?.state?.schedule?.map((item, itemIdx) => {
                    return (
                      <React.Fragment key={item?.id}>
                        <Box
                          sx={{
                            padding: "1rem",
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "1rem",
                            border: `1px solid ${getCssVariableHandler({
                              variableName: "--primary-pink-rgb",
                            })}`,
                            borderRadius: "1rem",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.75rem",
                            }}
                          >
                            <Typography sx={{ color: "white" }}>
                              {item?.positionOrder
                                ? `${item?.positionName} - ${item?.positionOrder}`
                                : item?.positionName}
                              <Typography
                                variant="span"
                                sx={{
                                  color: "#7AEFC6",
                                }}
                              >
                                {" "}
                                ({item?.eventName})
                              </Typography>
                            </Typography>
                            <Typography sx={{ color: "white" }}>
                              {getUniversalDateTimeFormat({
                                dateTime: item?.startDate,
                              })}
                            </Typography>
                          </Box>
                          <Box>
                            {/* <Typography 
                            sx={{ 
                              padding: "0.2rem 1rem",
                              borderRadius: "8px",
                              textTransform: "capitalize",
                              color: getTextColorOfStatus(item?.type),
                              border: `1px solid ${getColorOfStatus(item?.type)}`,
                              backgroundColor: getColorOfStatus(item?.type),
                            }}  
                          >
                            {item?.type}
                          </Typography> */}
                            <UnderlineButton
                              title={"View Details"}
                              onClick={() => {
                                const data = item;
                                navigate("/schedule", {
                                  state: { ...data, id: data?._id },
                                });
                                closeHandler();
                              }}
                            />
                          </Box>
                        </Box>
                      </React.Fragment>
                    );
                  })}
                </Box>
              </Box>
            ) : null}

            {rowData?.state?.multiple?.length > 0 || rowData?.state?.single ? (
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  backgroundColor: "#64646466",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "space-between",
                    // alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: "1.25rem",
                        fontWeight: "500",
                      }}
                    >
                      Opportunities
                    </Typography>
                  </Box>

                  {rowData?.state?.multiple?.map?.((multipleItem, i) => {
                    return (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "0.5rem 1rem",
                          gap: "0.5rem",
                          border: `1px solid ${getCssVariableHandler({
                            variableName: "--primary-pink-rgb",
                          })}`,
                          borderRadius: "1rem",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0.5rem 0",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "1.25rem",
                              fontWeight: "500",
                            }}
                          >
                            Event:{" "}
                            <Typography
                              variant="span"
                              sx={{
                                color: "#7AEFC6",
                              }}
                            >
                              {multipleItem?.data?.eventName}
                            </Typography>
                          </Typography>
                          <UnderlineButton
                            styles={{
                              alignSelf: "flex-end",
                            }}
                            title={"View Details"}
                            onClick={() => {
                              navigate("/opportunities", {
                                state: {
                                  ...multipleItem?.data,
                                },
                              });
                              closeHandler();
                            }}
                          />
                        </Box>
                        {multipleItem?.data?.positions?.map((item, itemIdx) => {
                          return (
                            <React.Fragment key={item?.id}>
                              <Box
                                sx={{
                                  padding: "1rem",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "1rem",
                                  border: `1px solid ${getCssVariableHandler({
                                    variableName: "--primary-pink-rgb",
                                  })}`,
                                  borderRadius: "1rem",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.75rem",
                                  }}
                                >
                                  <Typography sx={{ color: "white" }}>
                                    {item?.positionOrder
                                      ? `${item?.positionName} - ${item?.positionOrder}`
                                      : item?.positionName}
                                  </Typography>
                                  <Typography sx={{ color: "white" }}>
                                    {getUniversalDateTimeFormat({
                                      dateTime: item?.startDate,
                                    })}
                                  </Typography>
                                </Box>
                                <Typography
                                  sx={{
                                    // color: "white",
                                    padding: "0.2rem 1rem",
                                    borderRadius: "8px",
                                    textTransform: "capitalize",
                                    color: getTextColorOfStatus(item?.type),
                                    border: `1px solid ${getColorOfStatus(item?.type)}`,
                                    backgroundColor: getColorOfStatus(
                                      item?.type,
                                    ),
                                  }}
                                >
                                  {item?.type}
                                </Typography>
                              </Box>
                            </React.Fragment>
                          );
                        })}
                      </Box>
                    );
                  })}

                  {rowData?.state?.single ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <UnderlineButton
                          styles={{
                            alignSelf: "flex-end",
                            marginBottom: "0.5rem",
                          }}
                          title={"View Details"}
                          onClick={() => {
                            navigate("/opportunities", {
                              state: {
                                ...rowData?.state?.single,
                                id: rowData?.state?.single?.positions?.[0]?.id,
                                positionId:
                                  rowData?.state?.single?.positions[0]
                                    ?.positionId,
                              },
                            });

                            closeHandler();
                          }}
                        />

                        <Box
                          sx={{
                            padding: "1rem",
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "1rem",
                            border: `1px solid ${getCssVariableHandler({
                              variableName: "--primary-pink-rgb",
                            })}`,
                            borderRadius: "1rem",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.75rem",
                            }}
                          >
                            <Typography sx={{ color: "white" }}>
                              {
                                rowData?.state?.single?.positions?.[0]
                                  ?.positionName
                              }{" "}
                              <Typography
                                variant="span"
                                sx={{
                                  color: "#7AEFC6",
                                }}
                              >
                                {" "}
                                ({rowData?.state?.single?.eventName})
                              </Typography>
                            </Typography>
                            <Typography sx={{ color: "white" }}>
                              {getUniversalDateTimeFormat({
                                dateTime:
                                  rowData?.state?.single?.positions?.[0]
                                    ?.startDate,
                              })}
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              padding: "0.2rem 1rem",
                              borderRadius: "8px",
                              textTransform: "capitalize",
                              color: getTextColorOfStatus(
                                rowData?.state?.single?.positions?.[0]?.type,
                              ),
                              border: `1px solid ${getColorOfStatus(rowData?.state?.single?.positions?.[0]?.type)}`,
                              backgroundColor: getColorOfStatus(
                                rowData?.state?.single?.positions?.[0]?.type,
                              ),
                            }}
                          >
                            {rowData?.state?.single?.positions?.[0]?.type}
                          </Typography>
                        </Box>
                      </Box>
                    </>
                  ) : null}
                </Box>
              </Box>
            ) : null}

            {/* {rowData?.state?.single ? <Box
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                backgroundColor: "#64646466",
                padding: "1rem",
                borderRadius: "0.5rem",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "space-between",
                  // alignItems: "center",
                  gap: "1rem",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <UnderlineButton
                    title={"View Details"}
                    onClick={() => {
                      navigate("/opportunities", {
                        state: {
                          ...rowData?.state?.single,
                          id: rowData?.state?.single?.positions?.[0]?.id,
                          positionId: rowData?.state?.single?.positions[0]?.positionId,
                        },
                      });

                      closeHandler();
                    }}
                  />
                </Box>
                
                <Box
                  sx={{
                    padding: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-rgb"
                    })}`,
                    borderRadius: "1rem"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem"
                    }}
                  >
                    <Typography sx={{ color: "white" }}>
                      {rowData?.state?.single?.positions?.[0]?.positionName}
                    </Typography>
                    <Typography sx={{ color: "white" }}>
                      {dayjs(rowData?.state?.single?.positions?.[0]?.startDate).format("LL")}
                    </Typography>
                  </Box>
                  <Typography sx={{ 
                    padding: "0.2rem 1rem",
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    color: getTextColorOfStatus(rowData?.state?.single?.positions?.[0]?.type),
                    border: `1px solid ${getColorOfStatus(rowData?.state?.single?.positions?.[0]?.type)}`,
                    backgroundColor: getColorOfStatus(rowData?.state?.single?.positions?.[0]?.type), 
                  }}>
                    {rowData?.state?.single?.positions?.[0]?.type}
                  </Typography>
                </Box>
              </Box>
            </Box> : null} */}

            {/* <Box
              sx={{
                border: `1px solid ${theme.palette.secondary.main}`,
                width: "100%",
                borderRadius: "3px",
                height: "auto",
                padding: "10px",
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                fontSize: "14px",
                zIndex: "10",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  zIndex: "10",
                  "& p": {
                    width: "50%",
                  },
                }}
              >
                <Typography
                  sx={{
                    margin: "0 auto",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Date Start:{" "}
                  </span>
                  {dayjs(data?.startDate).format("DD MMM, YYYY")}
                </Typography>

                <Typography
                  sx={{
                    margin: "0 auto",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Overnight Shift:{" "}
                  </span>
                  {data?.overNightShift ? "Yes" : "No"}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  zIndex: "10",
                  "& p": {
                    width: "50%",
                  },
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    {" "}
                    Time In:{"  "}
                  </span>
                  {dateRegex.test(data?.timeIn?.split?.("T")?.[0])
                    ? formatAMPM(
                        convertFromUTCToGivenTimezone({
                          dateStr: data?.timeIn,
                          timezone: data?.timezone,
                        }),
                      )
                    : "TBD"}
                </Typography>
                <Typography
                  sx={{
                    margin: "0 auto",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Time End:{"  "}
                  </span>
                  {dateRegex.test(data?.timeOut?.split?.("T")?.[0])
                    ? formatAMPM(
                        convertFromUTCToGivenTimezone({
                          dateStr: data?.timeOut,
                          timezone: data?.timezone,
                        }),
                      )
                    : "TBD"}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  "& p": {
                    width: "50%",
                  },
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Complexity:{"  "}
                  </span>
                  {data?.complexity}
                </Typography>
                <Typography
                  sx={{
                    margin: "0 28%",
                  }}
                >
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    Attire:{"  "}
                  </span>
                  {data?.attire}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    {" "}
                    Meal Option:{"  "}
                  </span>
                  {data?.info}
                </Typography>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  <span
                    style={{
                      color: `${theme.palette.secondary.main}`,
                    }}
                  >
                    {" "}
                    Comments:{"  "}
                  </span>
                  {data?.comments}
                </Typography>
              </Box>
            </Box> */}
            {/* <Box
              sx={{
                backgroundColor: `${theme.palette.secondary.main}`,
                width: "100%",
                borderRadius: "3px",
                height: "auto",
                padding: "10px",
                gap: "5px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "14px",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: "0.5",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: -1,
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    zIndex: "10",
                    color: "rgba(245,245,245,1) !important",
                  }}
                >
                  <Typography>{data?.location}</Typography>
                  <Typography>{` ${rowData?.venue}, ${rowData?.venueAddressLine1}, ${rowData?.venueCity}, ${rowData?.venueState}, ${rowData?.venueZipCode}`}</Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: "10",
                }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  allowfullscreen
                  src={`https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_API_KEY}${
                    data?.lat && data?.long
                      ? `&center=${data.lat},${data.long}`
                      : ""
                  }&q=${encodeURIComponent(
                    [
                      rowData?.venue,
                      rowData?.venueAddressLine1,
                      rowData?.venueCity,
                      rowData?.venueState,
                      rowData?.venueZipCode,
                    ]
                      .filter(Boolean) // Remove falsy values
                      .join(", "), // Combine valid parts with a comma and space
                  )}`}
                ></iframe>
              </Box>
            </Box> */}
            {/* {showButtons && data?.pending && (
              <Box
                sx={{
                  width: "50%",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  margin: "0 auto",
                }}
              >
                <CustomButton onClick={handleAcceptClick}>
                  <Typography sx={{ fontSize: "1.5rem" }}>Accept</Typography>
                </CustomButton>
                <SecondaryButton onClick={handleDeclineClick}>
                  <Typography sx={{ fontSize: "1.5rem" }}>Decline</Typography>
                </SecondaryButton>
              </Box>
            )} */}
          </>
        ) : null}
      </Box>
    </Modal>
  );
};

export default CalendarMiddleware;

// CalendarMiddleware.propTypes = {
//   open: PropTypes.bool,
//   setOpen: PropTypes.func,
//   selectedRow: PropTypes.object,
//   showButtons: PropTypes.bool,
//   opportunityId: PropTypes.string,
//   id: PropTypes.string,
//   data: PropTypes.object,
//   setCount: PropTypes.func,
// };

// -----------------------------------------------------------------------------------------------------------
/* eslint-disable react/prop-types */
// import {
//   Box,
//   Button,
//   Modal,
//   Typography,
//   Divider,
//   useMediaQuery,
// } from "@mui/material";
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import theme from "../../../theme";
// import {
//   CustomButton,
//   SecondaryButton,
// } from "../../../components/Custom/CustomButton";
// import PropTypes from "prop-types";

// import WestIcon from "@mui/icons-material/West";

// import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
// import { alertDialogAciton } from "../../../store/actions/auth";
// import { apiRequest } from "../../../services/apiService";
// import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
// import dayjs from "dayjs";
// import {
//   applyOpportunityAction,
//   clearContractorAppliedListAction,
//   updateResponseAnyway,
// } from "../../../store/actions/opportunities";
// import {
//   convertFromUTCToGivenTimezone,
//   formatAMPM,
// } from "../../../utils/methods/dateAndTimeMethods";
// import { clearScheduleDataAction } from "../../../store/actions/contractorScheduleTabActions";
// import { dateRegex } from "../../../utils/constants/dateRegex";
// import { phoneNumberFormat } from "../../../utils/methods/formatters";
// import { ArrowForward } from "@mui/icons-material";
// import GenericTransparentBtn from "../../../components/Custom/GenericTransparentBtn";

// const CalendarMiddleware = ({
//   selectedRow,
//   showButtons = true,
//   opportunityId,
//   data: rowData,
//   setCount,
//   handleClose
// }) => {
//   console.log(rowData, "CalendarMiddleware");
//   // media query hooks...
//   const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
//   const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
//   // media query hooks...

//   const navigate = useNavigate();

//   const { oppLoading: loading } = useSelector((state) => state.opportunities);

//   const dispatch = useDispatch();
//   const [data, setData] = React.useState(null);
//   const [isLoading, setIsLoading] = React.useState(false);
//   const [contractorStatus, setContractorStatus] =
//     React.useState("not responded");
//   const [open, setOpen] = React.useState(true);

//   React.useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       const { response, error } = await apiRequest({
//         method: "GET",
//         url: "getOpportunityById",
//         version: "v2",
//         params: {
//           id: rowData?.state?.positions?.[0]?.id,
//           opportunityId: rowData?.state?.positions?.[0]?.opportunityId,
//         },
//         isToken: true,
//       });
//       if (response?.status === 200) {
//         setData(response?.data?.data);
//         setIsLoading(false);
//       } else if (response?.status !== 200 || error) {
//         setData(null);
//         setIsLoading(false);
//         dispatch(
//           alertDialogAciton({
//             open: true,
//             title: "Error",
//             message:
//               error?.response?.data?.message || "Fail to get opportunity!",
//           }),
//         );
//         setOpen(false);
//       }
//     };

//     if (rowData?.type !== "schedule") {
//       fetchData();
//     }
//   }, []);

//   React.useEffect(() => {
//     if (data?.applied) {
//       setContractorStatus("Applied");
//     } else if (data?.declined) {
//       setContractorStatus("Declined");
//     }
//   }, [data]);

//   const getColorOfStatus = (status) => {
//     switch (status?.toLowerCase()) {
//       case "draft":
//         return "#4D4D4D";
//       case "not responded":
//         return "#4D4D4D";
//       case "applied":
//         return "#02493E";
//       case "declined":
//         return "#371414";

//       default:
//         return "white";
//     }
//   };

//   const getTextColorOfStatus = (status) => {
//     switch (status?.toLowerCase()) {
//       case "draft":
//         return "black";
//       case "not responded":
//         return "white";
//       case "applied":
//         return "#07EEC5";
//       case "declined":
//         return "#FF4B4B";

//       default:
//         return "black";
//     }
//   };

//   const handleAcceptClick = () => {
//     dispatch(
//       applyOpportunityAction({
//         payload: {
//           data: {
//             response: "applied",
//           },
//           id: opportunityId,
//           params: {
//             positionId: data?.positionId,
//             sessionId: data?.sessionId,
//             Id: opportunityId,
//           },
//         },
//         successCallback: (rdata) => {
//           if (!rdata?.scheduledConflictContractors?.length) {
//             dispatch(
//               alertDialogAciton({
//                 title: "Success",
//                 message: "Opportunity accepted successfully!",
//                 open: true,
//               }),
//             );
//             dispatch(clearContractorAppliedListAction());
//             dispatch(clearScheduleDataAction());
//             setOpen(false);
//             setCount((prev) => prev + 1);
//           } else {
//             dispatch(
//               alertDialogAciton({
//                 open: true,
//                 title: "Conflict Alert",
//                 message: "You have a schedule conflict with this opportunity!",
//                 onOk: () => {
//                   dispatch(
//                     updateResponseAnyway({
//                       payload: {
//                         data: {
//                           response: "applied",
//                         },
//                         id: opportunityId,
//                         params: {
//                           positionId: data?.positionId,
//                           sessionId: data?.sessionId,
//                           Id: opportunityId,
//                         },
//                       },
//                       successCallback: () => {
//                         dispatch(
//                           alertDialogAciton({
//                             title: "Success",
//                             message: "Opportunity accepted successfully!",
//                             open: true,
//                           }),
//                         );
//                         dispatch(clearContractorAppliedListAction());
//                         dispatch(clearScheduleDataAction());
//                         setOpen(false);
//                         setCount((prev) => prev + 1);
//                       },
//                       failureCallback: (msg) => {
//                         dispatch(
//                           alertDialogAciton({
//                             title: "Error",
//                             message: msg || "Fail to accept opportunity!",
//                             open: true,
//                           }),
//                         );
//                       },
//                     }),
//                   );
//                 },
//                 okLabel: "Accept Anyway",
//               }),
//             );
//           }
//         },
//         failureCallback: (msg) => {
//           dispatch(
//             alertDialogAciton({
//               title: "Error",
//               message: msg?.message || "Fail to accept opportunity!",
//               open: true,
//             }),
//           );
//         },
//       }),
//     );
//   };

//   const handleDeclineClick = () => {
//     dispatch(
//       applyOpportunityAction({
//         payload: {
//           data: {
//             response: "declined",
//           },
//           id: opportunityId,
//           params: {
//             positionId: data?.positionId,
//             sessionId: data?.sessionId,
//             Id: opportunityId,
//           },
//         },
//         successCallback: () => {
//           dispatch(
//             alertDialogAciton({
//               title: "Success",
//               message: "Opportunity denied successfully!",
//               open: true,
//             }),
//           );
//           setOpen(false);
//           setCount((prev) => prev + 1);
//         },
//         failureCallback: () => {
//           dispatch(
//             alertDialogAciton({
//               title: "Error",
//               message: "Fail to accept opportunity!",
//               open: true,
//             }),
//           );
//         },
//       }),
//     );
//   };

//   const closeHandler = () => {
//     setOpen(false);
//     if (handleClose) {
//       handleClose();
//     }
//   }

//   return (
//     <Modal
//       // className="modelBox"
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//       open={open}
//       onClose={closeHandler}
//       // aria-labelledby="modal-modal-title"
//       // aria-describedby="modal-modal-description"
//     >
//       <Box
//         sx={{
//           position: "relative",
//           // top: "50%",
//           // left: "50%",
//           // transform: "translate(-50%, -50%)",
//           width: isMediumScreen ? "95%" : "60%",
//           // minWidth: "880px",
//           // minHeight: isLoading ? "60%" : "50%",
//           height: "auto",
//           maxHeight: "95%",
//           maxWidth: "1080px",
//           // minHeight: "500px",
//           boxShadow: 24,
//           p: 4,
//           borderRadius: "16px",
//           padding: "40px",
//           gap: "30px",
//           border: "2px solid #D175B6",
//           backgroundColor: "#000",
//           display: "flex",
//           flexDirection: "column",
//           zIndex: 9,
//           overflowY: "auto",
//           "@media (max-width: 600px)": {
//             minWidth: "0px",
//             width: "97vw",
//             maxHeight: "95vh",
//             overflowY: "auto",
//           },
//         }}
//         className="custom-scroll-design"
//       >
//         {rowData?.type !== "schedule" ? (isLoading || loading) && (
//           <LoadingOverlay open={isLoading || loading} />
//         ) : null}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "space-between",
//           }}
//         >
//           <Button
//             onClick={() => setOpen(false)}
//             sx={{
//               minWidth: "0",
//               height: "auto",
//               background: "none",
//               padding: isSmallScreen ? "0" : "0.5rem",
//               boxShadow: "none",
//               border: isSmallScreen
//                 ? "none"
//                 : `1px solid ${getCssVariableHandler({
//                     variableName: "--primary-pink-hex",
//                   })}`,
//               zIndex: "10",
//               borderRadius: "50%",
//               cursor: "pointer !important",
//               "&:hover": {
//                 minWidth: "0",
//                 background: "none",
//                 padding: isSmallScreen ? "0" : "0.5rem",
//                 boxShadow: "none",
//                 border: isSmallScreen
//                   ? "none"
//                   : `1px solid ${getCssVariableHandler({
//                       variableName: "--primary-pink-hex",
//                     })}`,
//                 borderRadius: "50%",
//               },
//             }}
//           >
//             <WestIcon />
//           </Button>
//           <Typography
//             id="modal-modal-title"
//             variant="h6"
//             component="h2"
//             marginBottom="20px"
//             sx={{
//               float: "left",
//               margin: "0 auto",
//               fontSize: "32px",
//               zIndex: "10",
//             }}
//           >
//             {dayjs(rowData?.type === "schedule" ? rowData?.state?.startDate : rowData?.state?.positions?.[0]?.startDate)?.format("LL")}
//           </Typography>
//         </Box>
//         {!isLoading ? (
//           <>
//             <Box sx={{ width: "100%" }}>
//               <Box
//                 sx={{
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   width: "100%",
//                   height: "auto",
//                   padding: "10px",
//                   gap: "5px",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   zIndex: "10",
//                 }}
//               >
//                 <Typography sx={{ fontSize: "20px" }}>
//                   Event Name: {rowData?.type === "schedule" ? rowData?.state?.eventName : data?.eventName}
//                 </Typography>
//                 {data?.coordinators?.length > 0 && (
//                   <Typography sx={{ fontSize: "14px", textWrap: "wrap" }}>
//                     Coordinator{data?.coordinators?.length > 1 ? "s" : ""}:{" "}
//                     {data?.coordinators
//                       ?.map(
//                         (item) =>
//                           `${item?.name} - (${phoneNumberFormat(item?.mobile)})`,
//                       )
//                       .join(", ")}
//                   </Typography>
//                 )}
//               </Box>
//               {/* {data?.adminMessage && (
//                 <Box
//                   sx={{
//                     width: "100%",
//                     textAlign: "center",
//                     mt: "0.5rem",
//                   }}
//                 >
//                   <Typography sx={{ fontSize: "14px" }}>
//                     Admin Message: {data?.adminMessage}
//                   </Typography>
//                 </Box>
//               )} */}
//             </Box>

//             <Box
//               sx={{
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 backgroundColor: "#64646466",
//                 padding: "1rem",
//                 borderRadius: "0.5rem",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "space-between",
//                   // alignItems: "center",
//                   gap: "1rem",
//                 }}
//               >
//                 {rowData?.type !== "schedule" ? rowData?.state?.positions?.map((item, itemIdx) => {
//                   return (
//                     <React.Fragment key={item?.id}>
//                       <Box
//                         sx={{
//                           padding: "1rem",
//                           display: "flex",
//                           gap: "1rem",
//                           border: `1px solid ${getCssVariableHandler({
//                             variableName: "--primary-pink-rgb"
//                           })}`,
//                           borderRadius: "1rem"
//                         }}
//                       >
//                         <Typography sx={{ color: "white" }}>
//                           {item?.positionName}
//                         </Typography>
//                         <Typography sx={{ color: "white" }}>
//                           {dayjs(item?.timeIn).format("LL")}
//                         </Typography>
//                       </Box>
//                     </React.Fragment>
//                   )
//                 }) : (
//                   <Box
//                     sx={{
//                       padding: "1rem",
//                       display: "flex",
//                       gap: "1rem",
//                       border: `1px solid ${getCssVariableHandler({
//                         variableName: "--primary-pink-rgb"
//                       })}`,
//                       borderRadius: "1rem"
//                     }}
//                   >
//                     <Typography sx={{ color: "white" }}>
//                       {rowData?.state?.positionName}
//                     </Typography>
//                     <Typography sx={{ color: "white" }}>
//                       {dayjs(rowData?.state?.timeIn).format("LL")}
//                     </Typography>
//                   </Box>
//                 )}
//               </Box>

//               <Button
//                 sx={{
//                   // color: getTextColorOfStatus(contractorStatus),
//                   // border: `1px solid ${getColorOfStatus(contractorStatus)}`,
//                   position: "absolute",
//                   // top: "50%",
//                   right: "1rem",
//                   // transform: `translateX(-100%)`,
//                   backgroundColor: getCssVariableHandler({
//                     variableName: "--primary-pink-rgb"
//                   }),
//                   minWidth: "0",
//                   padding: "1.8rem 0.75rem !important",
//                   borderRadius: "50%",
//                   textAlign: "center",
//                   height: "35px",
//                   textTransform: "capitalize",
//                 }}
//                 onClick={() => {
//                   if (rowData?.type === "schedule") {
//                     navigate("/schedule", { state: { ...rowData?.state, id: rowData?.state?._id } });
//                   } else if (rowData?.type === "single") {
//                     navigate("/opportunities", {
//                       state: {
//                         ...rowData?.state,
//                         id: rowData?.state?.positions?.[0]?.id,
//                         positionId: rowData?.state?.positions?.[0]?.positionId,
//                       },
//                     });
//                   } else {
//                     navigate("/opportunities", {
//                       state: {
//                         ...rowData?.state,
//                       },
//                     });
//                   }

//                   closeHandler();
//                 }}
//               >
//                 {/* {contractorStatus} */}
//                 <ArrowForward
//                   sx={{
//                     fontSize: "2rem",
//                     color: getCssVariableHandler({
//                       variableName: "--font-rgb"
//                     }),
//                   }}
//                 />
//               </Button>
//             </Box>

//             {/* <Box
//               sx={{
//                 border: `1px solid ${theme.palette.secondary.main}`,
//                 width: "100%",
//                 borderRadius: "3px",
//                 height: "auto",
//                 padding: "10px",
//                 gap: "10px",
//                 display: "flex",
//                 flexDirection: "column",
//                 fontSize: "14px",
//                 zIndex: "10",
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   zIndex: "10",
//                   "& p": {
//                     width: "50%",
//                   },
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     margin: "0 auto",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Date Start:{" "}
//                   </span>
//                   {dayjs(data?.startDate).format("DD MMM, YYYY")}
//                 </Typography>

//                 <Typography
//                   sx={{
//                     margin: "0 auto",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Overnight Shift:{" "}
//                   </span>
//                   {data?.overNightShift ? "Yes" : "No"}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   zIndex: "10",
//                   "& p": {
//                     width: "50%",
//                   },
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     {" "}
//                     Time In:{"  "}
//                   </span>
//                   {dateRegex.test(data?.timeIn?.split?.("T")?.[0])
//                     ? formatAMPM(
//                         convertFromUTCToGivenTimezone({
//                           dateStr: data?.timeIn,
//                           timezone: data?.timezone,
//                         }),
//                       )
//                     : "TBD"}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     margin: "0 auto",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Time End:{"  "}
//                   </span>
//                   {dateRegex.test(data?.timeOut?.split?.("T")?.[0])
//                     ? formatAMPM(
//                         convertFromUTCToGivenTimezone({
//                           dateStr: data?.timeOut,
//                           timezone: data?.timezone,
//                         }),
//                       )
//                     : "TBD"}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   "& p": {
//                     width: "50%",
//                   },
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Complexity:{"  "}
//                   </span>
//                   {data?.complexity}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     margin: "0 28%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     Attire:{"  "}
//                   </span>
//                   {data?.attire}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     {" "}
//                     Meal Option:{"  "}
//                   </span>
//                   {data?.info}
//                 </Typography>
//               </Box>
//               <Divider
//                 sx={{
//                   width: "100%",
//                   border: `1px solid ${theme.palette.secondary.main}`,
//                 }}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <Typography>
//                   <span
//                     style={{
//                       color: `${theme.palette.secondary.main}`,
//                     }}
//                   >
//                     {" "}
//                     Comments:{"  "}
//                   </span>
//                   {data?.comments}
//                 </Typography>
//               </Box>
//             </Box> */}
//             {/* <Box
//               sx={{
//                 backgroundColor: `${theme.palette.secondary.main}`,
//                 width: "100%",
//                 borderRadius: "3px",
//                 height: "auto",
//                 padding: "10px",
//                 gap: "5px",
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 fontSize: "14px",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "50%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   opacity: "0.5",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: "rgba(0, 0, 0, 0.5)",
//                     zIndex: -1,
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "relative",
//                     zIndex: "10",
//                     color: "rgba(245,245,245,1) !important",
//                   }}
//                 >
//                   <Typography>{data?.location}</Typography>
//                   <Typography>{` ${rowData?.venue}, ${rowData?.venueAddressLine1}, ${rowData?.venueCity}, ${rowData?.venueState}, ${rowData?.venueZipCode}`}</Typography>
//                 </Box>
//               </Box>
//               <Box
//                 sx={{
//                   width: "50%",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   zIndex: "10",
//                 }}
//               >
//                 <iframe
//                   width="100%"
//                   height="100%"
//                   loading="lazy"
//                   allowfullscreen
//                   src={`https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_API_KEY}${
//                     data?.lat && data?.long
//                       ? `&center=${data.lat},${data.long}`
//                       : ""
//                   }&q=${encodeURIComponent(
//                     [
//                       rowData?.venue,
//                       rowData?.venueAddressLine1,
//                       rowData?.venueCity,
//                       rowData?.venueState,
//                       rowData?.venueZipCode,
//                     ]
//                       .filter(Boolean) // Remove falsy values
//                       .join(", "), // Combine valid parts with a comma and space
//                   )}`}
//                 ></iframe>
//               </Box>
//             </Box> */}
//             {/* {showButtons && data?.pending && (
//               <Box
//                 sx={{
//                   width: "50%",
//                   height: "auto",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: "10px",
//                   margin: "0 auto",
//                 }}
//               >
//                 <CustomButton onClick={handleAcceptClick}>
//                   <Typography sx={{ fontSize: "1.5rem" }}>Accept</Typography>
//                 </CustomButton>
//                 <SecondaryButton onClick={handleDeclineClick}>
//                   <Typography sx={{ fontSize: "1.5rem" }}>Decline</Typography>
//                 </SecondaryButton>
//               </Box>
//             )} */}
//           </>
//         ) : null}
//       </Box>
//     </Modal>
//   );
// }

// export default CalendarMiddleware;

// // CalendarMiddleware.propTypes = {
// //   open: PropTypes.bool,
// //   setOpen: PropTypes.func,
// //   selectedRow: PropTypes.object,
// //   showButtons: PropTypes.bool,
// //   opportunityId: PropTypes.string,
// //   id: PropTypes.string,
// //   data: PropTypes.object,
// //   setCount: PropTypes.func,
// // };